export default __webpack_public_path__ + "static/citlali-72238f5052270fa3e9222b6aaa3a7184.png";